export default "__VITE_ASSET__382582e9__"